import React from "react";
import { ClipLoader } from "react-spinners";
import styles from "./styles.module.css";

const BotaoPadrao = ({onClick, isLoading = false, label, disabled}) => {
    return (
        <button
        type="button"
        className={styles.botaoPadrao}
        disabled={isLoading || disabled}
        onClick={onClick}
        >
            {isLoading ? (
                <ClipLoader size={15} color="#FFFFFF" />
            ) : (
                label
            )}
        </button>
    );
}

export default BotaoPadrao;